import React, { useCallback, useEffect } from 'react'

import { FormProvider, useForm } from 'react-hook-form'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import { CalendarTimePicker } from '@/modules/online-mass-messages/ui/time-calendar/calendar-time-picker.tsx'

const DEFAULT_FROM_DATE = new Date()

DEFAULT_FROM_DATE.setHours(0, 0)
const DEFAULT_TO_DATE = new Date()

DEFAULT_TO_DATE.setHours(23, 59)

export interface CustomTimePopupFormValues {
  fromTime: Date
  toTime: Date
}

interface CustomTimePopupProps {
  title: string
  fromTime?: Date | null
  toTime?: Date | null
  open: boolean
  onClose: () => void
  update: (formValues: CustomTimePopupFormValues) => void
}

export const CustomTimePopup = ({
  title,
  fromTime,
  toTime,
  open,
  onClose,
  update,
}: CustomTimePopupProps) => {
  const form = useForm<CustomTimePopupFormValues>({
    defaultValues: {
      fromTime: fromTime || DEFAULT_FROM_DATE,
      toTime: toTime || DEFAULT_TO_DATE,
    },
  })

  useEffect(
    () => {
      form.reset({
        fromTime: fromTime || DEFAULT_FROM_DATE,
        toTime: toTime || DEFAULT_TO_DATE,
      })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fromTime, toTime],
  )

  const handleSave = useCallback(
    (values: CustomTimePopupFormValues) => {
      update(values)
    },
    [update],
  )

  return (
    <Dialog
      show={open}
      bigDialog={true}
      onClose={onClose}
    >
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSave)}>
          <Dialog.Header>
            <Dialog.Title>{title}</Dialog.Title>
            <Dialog.Description className="text-center">
              Select a time window, in which the feature should be running
              automatically
            </Dialog.Description>
          </Dialog.Header>

          <Dialog.Description>
            <div className="mt-6 flex items-center justify-between">
              <span className="text-label-primary text-base">From Time</span>
              <CalendarTimePicker name="fromTime" />
            </div>
            <div className="mt-6 flex items-center justify-between">
              <span className="text-label-primary text-base">To Time</span>
              <CalendarTimePicker name="toTime" />
            </div>
          </Dialog.Description>

          <Dialog.Footer>
            <Button
              className="w-full"
              type="submit"
            >
              Save
            </Button>
          </Dialog.Footer>
        </form>
      </FormProvider>
    </Dialog>
  )
}
